import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = () => {
  const isAuthenticated = localStorage.getItem("superAdminToken");

  return isAuthenticated ? <Outlet /> : <Navigate to="/super_admin/login" replace />;
};

export default PrivateRoute;
